module.exports = __webpack_public_path__ + "img/far-video-slash.c1aa6655.svg";